module.exports = __webpack_public_path__ + "static/media/hillmac.c8e26e5b.png";